module.exports = __webpack_public_path__ + "img/45.8f957ba7.png";